import useMuiMediaQuery from '@mui/material/useMediaQuery';
import type {Theme} from '@mui/material/styles';
import {Breakpoint} from '@mui/material';

type ThemedQuery = (theme: Theme) => string;

export function useMediaQuery(queryInput: string | ThemedQuery) {
  return useMuiMediaQuery(queryInput, {
    noSsr: true,
  });
}

export function useIsBetween(min: Breakpoint, max: Breakpoint) {
  return useMediaQuery(theme => theme.breakpoints.between(min, max));
}

export function useIsDownXl() {
  return useMediaQuery(theme => theme.breakpoints.down('xl'));
}

export function useIsDownLg() {
  return useMediaQuery(theme => theme.breakpoints.down('lg'));
}

export function useIsDownMd() {
  return useMediaQuery(theme => theme.breakpoints.down('md'));
}

export function useIsDownSm() {
  return useMediaQuery(theme => theme.breakpoints.down('sm'));
}

export function useIsDownXs() {
  return useMediaQuery(theme => theme.breakpoints.down('xs'));
}

export function useIsUpSm() {
  return useMediaQuery(theme => theme.breakpoints.up('sm'));
}

export function useIsUpMd() {
  return useMediaQuery(theme => theme.breakpoints.up('md'));
}

export function useIsUpLg() {
  return useMediaQuery(theme => theme.breakpoints.up('lg'));
}

export function useWithHover() {
  return useMediaQuery('(hover: hover)');
}
